import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  openId: null,
  specInfo: null,
  orderInfo: null,
  processedPhoto: null,
	processedPhotoNoFair:null,
  bgColor: 0,
  searchResults: null,
  lastSearchWord: null,
  hotSearch: null,
  serviceTelNumber: null,
  consigneeInfo: null,
  price: null,
  printPhotoQty: 1,
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
});

